import css from 'styles/info.module.css'
import { circleCheckSolid } from 'assets'
import { blockExplorerUrl, contractAddress } from 'utils'

export default function Info() {
  return (
    <div className={css.address}>
      <div className={css.text}>
        <p>VERIFIED SMART CONTRACT ADDRESS:</p>
        <img
          src={circleCheckSolid}
          width={14}
          height={14}
          alt="verified circle check"
        />
      </div>
      <a
        className={css.href}
        href={`${blockExplorerUrl}address/${contractAddress}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {contractAddress}
      </a>
    </div>
  )
}
